<div class="flex flex-row w-full justify-between items-center ml-2">
    <div class="flex flex-row items-center">
        <fa-icon
            class="text-secondary"
            size="2xl"
            [icon]="icon() ?? ''" />
        <span class="text-3xl ml-4">
            {{ title() | transloco }}
        </span>
    </div>
    <ng-content />
</div>
